import { BREAKPOINTS, SETTINGS } from '../utils/constants';
import { throttle } from 'throttle-debounce';

const initAccordion = () => {
  const accordionEls = document.querySelectorAll('[data-accordion-summary]');
  const mobileAccordionAttr = 'data-mobile-accordion';
  const accordionContentEl = '[data-accordion-content]';
  const isDesktop = () => window.innerWidth >= BREAKPOINTS.DESKTOP;

  const openAccordion = (summary, content) => {
    summary.setAttribute('open', '');
    content.style.height = `${content.scrollHeight}px`;
  };

  const closeAccordion = (summary, content) => {
    content.style.height = `${content.scrollHeight}px`;
    requestAnimationFrame(() => { content.style.height = '0px'; });
    content.addEventListener('transitionend', () => summary.removeAttribute('open'), { once: true });
  };

  const animateAccordion = (summary, content) => {
    const summaryToggle = summary.querySelector(':scope > summary');
    if (!summaryToggle) return;

    summaryToggle.addEventListener('click', evt => {
      evt.preventDefault();
      const isMobileOnly = summary.hasAttribute(mobileAccordionAttr);
      if (isMobileOnly && isDesktop()) return;
      summary.open ? closeAccordion(summary, content) : openAccordion(summary, content);
    });
  };

  const recalcHeights = () => {
    accordionEls.forEach(summary => {
      const content = summary.querySelector(accordionContentEl);
      if (!content) return;
      const isMobileOnly = summary.hasAttribute(mobileAccordionAttr);

      if (isMobileOnly && isDesktop()) {
        summary.setAttribute('open', '');
        content.style.transition = 'none';
        content.style.height = 'auto';
        content.style.height = `${content.scrollHeight}px`;
        requestAnimationFrame(() => { content.style.transition = ''; });
      } else if (isMobileOnly && !isDesktop()) {
        if (summary.open) {
          content.style.transition = 'none';
          content.style.height = 'auto';
          content.style.height = `${content.scrollHeight}px`;
          requestAnimationFrame(() => { content.style.transition = ''; });
        }
      } else if (summary.open) {
        content.style.height = 'auto';
        content.style.height = `${content.scrollHeight}px`;
      }
    });
  };

  const toggleMobileOnly = () => {
    accordionEls.forEach(summary => {
      const content = summary.querySelector(accordionContentEl);
      if (!content || !summary.hasAttribute(mobileAccordionAttr)) return;

      if (isDesktop()) {
        summary.setAttribute('open', '');
        content.style.transition = 'none';
        content.style.height = `${content.scrollHeight}px`;
        requestAnimationFrame(() => { content.style.transition = ''; });
      } else {
        summary.removeAttribute('open');
        content.style.transition = 'none';
        content.style.height = '0px';
        requestAnimationFrame(() => { content.style.transition = ''; });
      }
    });
  };

  accordionEls.forEach(summary => {
    const content = summary.querySelector(accordionContentEl);
    if (!content) return;
    const isMobileOnly = summary.hasAttribute(mobileAccordionAttr);

    if (isMobileOnly && isDesktop()) {
      summary.setAttribute('open', '');
      content.style.height = `${content.scrollHeight}px`;
    } else {
      content.style.height = summary.open ? `${content.scrollHeight}px` : '0px';
    }
    animateAccordion(summary, content);
  });

  window.addEventListener('resize', throttle(SETTINGS.THROTTLE_DELAY, () => {
    toggleMobileOnly();
    recalcHeights();
  }));
};

export default initAccordion;
